import React from "react";
import HeaderOne from "../Components/Header/HeaderOne";
import Breadcrumb from "../Components/BreadCrumb/Breadcrumb";
import CartInner from "../Components/Shop/CartInner";
import FooterFour from "../Components/Footer/FooterOne";
import ScrollToTop from "../Components/ScrollToTop";
import { Helmet } from "react-helmet-async";

function Cart() {
  return (
    <>
      <Helmet>
        <title>Your Cart | Printers Friendly</title>
      </Helmet>
      <HeaderOne />
      <Breadcrumb title="Your Cart" />
      <CartInner />
      <FooterFour />
      <ScrollToTop />
    </>
  );
}

export default Cart;
